<template>
  <div class="paymentapp">
        <public-title >
            用户实名认证
            <!-- <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回上一页</span> -->
        </public-title>
         <div class="bg-white load-area">
            <p v-if="total<=0" class="mt-3">当前没有数据</p>
            <div v-else class="el-tables">
                <template>
                <el-table
                    :data="list"
                    border
                    stripe
                    style="width: 100%">
                    <!--表单内容-->
                    <el-table-column v-for="(item,index) in fundsForm" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center">
                    <!-- 自定义表头 -->
                    <template slot="header" slot-scope="scope">
                        <span>{{ scope.column.label }}</span>
                        <!-- <p v-if="item.total">{{ AdminDataLists.info.total[item.total] /100 | formatMoney}}</p> -->
                    </template>
                    <template slot-scope="scope">
                        <!--订单号-->
                        <div class="cursor-pointer pointers" :class="{'text-center':item.center}" v-if="item.pattern==='image'">
                            <upload-image  :existImgs="scope.row[item.prop]" :maxLength="1" class="mr-4" noMargin />
                            <upload-image  :existImgs="scope.row.card_b" :maxLength="1" noMargin />
                        </div>
                        <!--时间-->
                        <div :class="{'text-center':item.center}" v-else-if="item.pattern==='time'">{{ scope.row[item.prop]| formatTimestamp(5)}}</div>
                        <!--其他-->
                        <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
                    </template>
                    </el-table-column>
                    <!--操作按钮-->
                    <el-table-column
                    fixed="right"
                    header-align="center"
                    label="操作"
                    width="100">
                    <template slot-scope="scope">
                        <el-dropdown @command="handleCommand($event,scope.row)">
                            <el-button  class="el-dropdown-link text-link" type="text" size="small" style="margin: 0 auto; display: block;">查看<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item  command="1">审核通过</el-dropdown-item>
                            <el-dropdown-item  command="2">审核拒绝</el-dropdown-item>
                        </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="el-pagination mt-4" >
                    <el-pagination background layout="total,prev, pager, next" 
                        :page-size="10"
                        :total="total" :current-page="Number(formData.page)"
                        @current-change="$GFUN.pageChange"/>
                </div>
                </template>
            </div>
         </div>
         <!--同意审核弹窗-->
         <el-dialog
            title="同意审核"
            :visible.sync="dialogVisible"
            width="30%"
            >
            <el-form :model="ruleForm"  ref="ruleForm" label-width="120px">
                <el-form-item label="用户姓名" prop="truename">
                    <el-input v-model="ruleForm.truename" placeholder="请输入用户姓名"></el-input>
                </el-form-item>
                <el-form-item label="用户身份证号" prop="card">
                    <el-input v-model="ruleForm.card" placeholder="请输入用户身份证号"></el-input>
                </el-form-item>
            </el-form>
            <el-button  @click="dialogVisible = false">返回</el-button>
            <el-button type="primary" @click="submitForm();dialogVisible = false;">通过</el-button>
        </el-dialog>
  </div>
</template>

<script>
 import { mapGetters,mapActions,mapState} from 'vuex'
 import { debounce } from "lodash";
export default {
  name: 'PaymentApplication',
  components: {},
  props: {},
  data() {
    return {
        formData:{
            page:1,
            status:4,
            num:10,
        },
        list: [],
        total: 0,
        //搜索条件
        searchCon:{},
        loading: true,
        fundsForm:[
          {name:'用户ID',prop:'uid',center:true,width:100},
          {name:'用户姓名',prop:'truename',center:true,width:100},
          {name:'用户身份证号',prop:'card',center:true,width:400},
          {name:'上传身份证',prop:'card_a',center:true,minWidth:300,pattern:'image'},
          {name:'提交时间',prop:'add_time',center:true,minWidth:100,pattern:'time'},
        ],
        //提交申请弹窗
        count:0,               //倒计时
        currentItem:{},
        ruleForm:{
            id:'',
            action:'',
            truename:'',
            card:'',

        },
        isDisabled:true,
        dialogVisible:false,
    };
  },
  computed: {
        ...mapState(['newMessageInform']),
        ...mapGetters(['storeInfo', 'userInfo', 'isAdmin', 'isGroup']),
  },
  watch: {  
        newMessageInform(newVal) {
            //收到通知刷新当前页面
            if(newVal.type==62){
                this.initial();
            }
        },
        '$route.query':{
            handler(toVal,fromVal){
                this.formData.page=toVal.page||1
                this.initial();
            },
            immediate:true
        }
  },
  created() {},
  mounted() {},
  methods: {
     ...mapActions(['POST_RealVerifyList','POST_RealVerify']),
        //初始化
        initial(){
            this.formData={...this.formData,...this.searchCon}
            this.getOrderList();
        },
        getOrderList: debounce(function() {
            this.loading = true;
            this.POST_RealVerifyList({
                data:this.$_Object.removeEmptyProps(this.formData),
                successFun:(res)=>{
                //如果是酒店待报价合并同一个订单按oid分组合并
                this.total = res.count;
                this.loading = false;
                this.list = res.list;
            }});
        },300),
        /*根据条件搜索订单*/
        getSearchCon(con) {
            this.searchCon = con||{};
            if (this.formData.page == 1) {this.initial()}
            else {
                this.$router.push({
                    name: this.$route.query.name,
                    query: {...this.formData, page: 1}
                })
            };
            
        },
        //点击操作按钮
        handleCommand(command,Itemize) {
            this.revoke(Itemize,command);
        },
        //撤销提交
        revoke(item,command){
            this.ruleForm = {
                id: item.id,
                truename: item.truename,
                card: item.card,
                action: command
            }
            if(command==1){
                this.dialogVisible = true;
                return;
            }
            this._confirm(command==1?'是否通过此身份认证信息？':'是否拒绝此身份认证信息？',async () => {
                this.submitForm();
            });
        },
        //打款
        submitForm: debounce(function(){
            this.POST_RealVerify({
                data:this.ruleForm,
                successFun: () => {
                    this._alert('操作成功');
                    this.initial();
                }
            }); 
        },300),
  }
};
</script>

<style>
    .paymentapp .el-dropdown{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .pointers{
        display: flex;
        justify-content: center;
    }
</style>
